import React from "react";
import PropTypes from 'prop-types';
import StockPrice from '../Graphs/StockPrice';
import PublicSentiment from '../Graphs/PublicSentiment';
import BoardSentiment from '../Graphs/BoardSentiment';
import ProfitLoss from '../Graphs/ProfitLoss';
import Factory from '../Graphs/Factory';
import NewsArticle from '../Graphs/NewsArticle';
import { Grid } from "@material-ui/core";

const HomeGrid = (props) => {

  let hasStory = false;
  if (!props.coresim.completed && props.coresim.quarters[props.quarter].article){
    hasStory = true;
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={6} md={hasStory ? 3 : 4}>
        <StockPrice teamIndex={props.teamIndex} />
      </Grid>
      <Grid item xs={6} sm={6} md={hasStory ? 3 : 4}>
        <ProfitLoss teamIndex={props.teamIndex} />
      </Grid>
      <Grid item xs={6} sm={6} md={hasStory ? 3 : 4}>
        <PublicSentiment teamIndex={props.teamIndex} />
      </Grid>
      <Grid item xs={6} sm={6} md={hasStory ? 3 : 6}>
        <BoardSentiment teamIndex={props.teamIndex} />
      </Grid>
      { hasStory &&
        <Grid item xs={12} sm={12} md={6}>
          <NewsArticle data={props.quarters[props.quarter].article}/>
        </Grid>
      }
      <Grid item xs={12} sm={12} md={6}>
        <Factory teamIndex={props.teamIndex} />
      </Grid>
    </Grid>
  );
};

HomeGrid.propTypes = {
  teamIndex: PropTypes.number.isRequired,
  coresim: PropTypes.array.isRequired,
  quarter: PropTypes.number.isRequired,
  quarters: PropTypes.array
}

export default HomeGrid;
